import { render, staticRenderFns } from "./TheRegistrationManagement.vue?vue&type=template&id=903a1b56&scoped=true"
import script from "./TheRegistrationManagement.vue?vue&type=script&lang=js"
export * from "./TheRegistrationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903a1b56",
  null
  
)

export default component.exports